<template>
  <div class="header-search">
    <a href="../index.html">
      <img src="../../assets/imgs/header-logo.png" style="height:50px;" />
    </a>
    <div class="header-search-model">
      <input type="text" v-model="searchText" placeholder="淬火油" @focus="toFocus" @blur="toBlur" />
      <div class="header-search-btn" @click="toSearch()">
        <i class="iconfont icon-sousuo"></i>
        搜索
      </div>
      <el-select
        v-model="value"
        style="width: 100px; position: absolute; top: 0; line-height: 42px;"
      >
        <el-option v-for="item in types" :key="item.type" :label="item.label" :value="item.type"></el-option>
      </el-select>
      <ul v-show="hotKey">
        <li
          v-for="item in hotwordConfigs"
          :key="item.id"
          @click="toListSearch(item.name)"
        >{{ item.name }}</li>
      </ul>
    </div>
  </div>
</template>
<script>
import '@/assets/font-icon/iconfont.css'
export default {
  name: 'HeaderSearch',
  data () {
    return {
      searchText: '',
      hotKey: false,
      value: 'article',
      types: [{ 'type': 'product', label: '产品' }, { 'type': 'article', label: '文章' }]
    }
  },
  created () {
  },
  methods: {
    toListSearch (name) {
      if (this.value === 'article') {
        const _router = this.$router
        if (_router.currentRoute.name === 'Articles') {
          this.$emit('SearchChange', name)
        } else {
          this.$router.push({ name: 'Articles', query: { keyStr: name } })
        }
      } else {
        window.location.href = '../products-list-withkey.html?searchKeyWord=' + name
      }
    },
    toSearch () {
      if (this.value === 'article') {
        let _key = ''
        if (!this.searchText) {
          _key = '淬火油'
        } else {
          _key = this.searchText
        }
        const _router = this.$router
        if (_router.currentRoute.name === 'Articles') {
          this.$emit('SearchChange', _key)
        } else {
          this.$router.push({ name: 'Articles', query: { keyStr: _key } })
        }
      } else {
        if (!this.searchText) {
          window.location.href = '../products-list-withkey.html?searchKeyWord=' + '淬火油'
        } else {
          window.location.href = '../products-list-withkey.html?searchKeyWord=' + this.searchText
        }
      }
    },
    toFocus () {
      this.hotKey = true
    },
    toBlur () {
      const _that = this
      setTimeout(() => {
        _that.hotKey = false
      }, 500)
    }
  },
  computed: {
    hotwordConfigs () {
      return this.$store.getters.hotwordConfigs
    },
  }
}
</script>
<style lang="less" scoped>
.header-search {
  width: 1190px;
  height: 60px;
  line-height: 60px;
  background: #ffffff;
  min-width: 1190px;
  margin: 0 auto;
  position: relative;
  a {
    img {
      max-width: 100%;
      vertical-align: middle;
    }
  }
  .header-search-model {
    height: 42px;
    width: 570px;
    border: 2px solid #f13a58;
    border-radius: 5px;
    position: relative;
    display: inline-block;
    margin-left: 450px;
    input {
      width: 320px;
      height: 42px;
      border: 0px;
      float: left;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      padding: 0px 10px;
      margin-left: 110px;
    }
    .header-search-btn {
      cursor: pointer;
      width: 108px;
      height: 40px;
      margin-left: 460px;
      border: 1px solid #e0e0e0;
      background: #f13a58;
      color: #ffffff;
      text-align: center;
      border-bottom-right-radius: 5px;
      border-top-right-radius: 5px;
      line-height: 40px;
      font-size: 16px;
      i {
        font-size: 18px;
        margin-right: 10px;
      }
    }

    ul {
      width: 360px;
      position: absolute;
      top: 44px;
      background: #fff;
      border: 1px solid #e0e0e0;
      z-index: 100;
      margin-left: 100px;
      li {
        cursor: default;
        line-height: 25px;
        color: #555;
        padding: 0 10px;
        z-index: 101;
      }
      li:hover {
        background: #f0f1f2;
      }
    }
  }
}
</style>